 <div class="pagination-container">
                <div class="pagination-info">
                    <!-- <span>Total {{ totalPages }} Pages</span> -->
                      <span>Total {{ totalPages }} {{ totalPages === 1 ? 'Page' : 'Pages' }}</span>
                </div>

                <div class="pagination-controls">
                    <button class="pagination-btn prev-btn" [disabled]="currentPage === 1" (click)="previousPage()">
                        <i class="bi bi-chevron-left"></i>
                        Previous
                    </button>

                    <div class="page-numbers">
                        <button *ngFor="let page of getVisiblePageNumbers()" class="page-btn"
                            [class.active]="page === currentPage" (click)="goToPage(page)">
                            {{ page }}
                        </button>
                    </div>

                    <button class="pagination-btn next-btn" [disabled]="currentPage === totalPages"
                        (click)="nextPage()">
                        Next
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>